// gridSizeMdLg12
import { gridSizeMdLg6 } from "@/shared";
import {
  // CustomTextAreaNoForm,
  CustomTextField,
  CustomTextFieldNoForm,
  TabTextLabel,
} from "@/shared/components/ui";
// import { FormControl, Grid } from "@mui/material";
// import {
//   LocalizationProvider,
//   renderTimeViewClock,
//   TimePicker,
// } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { useState } from "react";
// import { Controller } from "react-hook-form";

export type ActivacionInstallOTClientDataFormTabProps = {
  form: any;
};

const ActivacionInstallOTClientDataFormTab: React.FC<
  ActivacionInstallOTClientDataFormTabProps
> = ({ form }) => {
  const { errors } = form.formState;
  const shrink = true;
  // const [minTimePyL, setMinTimePyL] = useState<any | null>(null);
  console.log({dataform: form.getValues()});

  return (
    <>
      <TabTextLabel text="FECHA Y HORA DE INSTALACIÓN" pb={1} pt={1} mt={0} />
      <CustomTextFieldNoForm
        label="Fecha de Instalación"
        value={form.getValues()?.fecha_instalacion||"Fecha no registrada"}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextFieldNoForm
        label="Hora de Instalación"
        value={form.getValues()?.hora_instalacion||"Hora no registrada"}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextField
        name="razon_social"
        label="Razón social"
        control={form.control}
        defaultValue={form.getValues()?.prospecto_data?.razon_social || ''}
        error={errors?.prospecto_data?.razon_social}
        helperText={errors?.prospecto_data?.razon_social?.message?.toString() ?? ''}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextField
        name="identificacion"
        label="No. Identificación"
        control={form.control}
        defaultValue={form.getValues()?.prospecto_data?.identificacion || ''}
        error={errors?.prospecto_data?.identificacion}
        helperText={errors?.prospecto_data?.identificacion?.message?.toString() ?? ''}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />
      
      <CustomTextField
        name="plan_data.nombre"
        label="Plan"
        control={form.control}
        defaultValue={form.getValues()?.plan_data?.nombre || ''}
        error={errors?.plan_data?.nombre}
        helperText={errors?.plan_data?.nombre?.message?.toString() ?? ''}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextField
        name="plan_data.velocidad_descarga_minima"
        label="Velocidad Contratada"
        control={form.control}
        defaultValue={form.getValues()?.plan_data?.velocidad_descarga_minima || ''}
        error={errors?.plan_data?.velocidad_descarga_minima}
        helperText={errors?.plan_data?.velocidad_descarga_minima?.message?.toString() ?? ''}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />

      {/* <TabTextLabel text="HORA INICIO/FIN" pb={0} pt={1} mt={2} />
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <Controller
            control={form.control}
            name="hora_inicio"
            render={({ field }) => {
              const onChange = (time: any) => {
                field.onChange(time);
                setMinTimePyL(time);
              };

              return (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    {...field}
                    value={field.value || null}
                    label="Hora de inicio técnico"
                    slotProps={{
                      textField: {
                        error: !!errors.hora_inicio,
                        required: true,
                        helperText: errors.hora_inicio?.message,
                      },
                    }}
                    viewRenderers={{
                      hours: renderTimeViewClock,
                      minutes: renderTimeViewClock,
                      seconds: renderTimeViewClock,
                    }}
                    onChange={onChange}
                  />
                </LocalizationProvider>
              );
            }}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <Controller
            control={form.control}
            name="hora_fin"
            render={({ field }) => {
              return (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    {...field}
                    value={field.value || null}
                    label="Hora de finalización técnico"
                    slotProps={{
                      textField: {
                        error: !!errors.hora_fin,
                        required: true,
                        helperText: errors.hora_fin?.message,
                      },
                    }}
                    viewRenderers={{
                      hours: renderTimeViewClock,
                      minutes: renderTimeViewClock,
                      seconds: renderTimeViewClock,
                    }}
                    minTime={minTimePyL || null}
                  />
                </LocalizationProvider>
              );
            }}
          />
        </FormControl>
      </Grid> */}

      {/* <TabTextLabel text="Cliente" pb="24px" pt="12px" /> */}
      <>
        {/* <CustomTextField
          name="tipo_identificacion"
          label="Tipo de Identificación"
          control={form.control}
          defaultValue={form.getValues().tipo_identificacion || ""}
          error={errors.tipo_identificacion}
          helperText={errors.tipo_identificacion?.message?.toString() ?? ""}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />

        <CustomTextField
          name="identificacion"
          label="No. Identificación"
          control={form.control}
          defaultValue={form.getValues().identificacion || ""}
          error={errors.identificacion}
          helperText={errors.identificacion?.message?.toString() ?? ""}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />

        <CustomTextField
          name="razon_social"
          label="Nombre"
          control={form.control}
          defaultValue={form.getValues().razon_social || ""}
          error={errors.razon_social}
          helperText={errors.razon_social?.message?.toString() ?? ""}
          shrink={shrink}
          disabled
        />
        <CustomTextField
          name="linea"
          label="Línea Contratada"
          control={form.control}
          defaultValue={form.getValues().prospecto_data?.linea || ""}
          error={errors.linea}
          helperText={errors.linea?.message?.toString() ?? ""}
          shrink={shrink}
          size={gridSizeMdLg12}
          disabled
        /> */}
        {/* <CustomTextField
          name="fecha_nacimiento"
          label="Fecha de Nacimiento"
          control={form.control}
          defaultValue={form.getValues().fecha_nacimiento || ""}
          error={errors.fecha_nacimiento}
          helperText={errors.fecha_nacimiento?.message?.toString() ?? ""}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        /> */}
        {/* <CustomTextField
          name="edad"
          label="Edad"
          control={form.control}
          defaultValue={form.getValues().edad || ""}
          error={errors.edad}
          helperText={errors.edad?.message?.toString() ?? ""}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        /> */}
        {/* <CustomTextField
          name="nacionalidad"
          label="Nacionalidad"
          control={form.control}
          defaultValue={form.getValues().nacionalidad || ""}
          error={errors.nacionalidad}
          helperText={errors.nacionalidad?.message?.toString() ?? ""}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        /> */}
        {/* <CustomTextField
          name="condicion_residencia"
          label="Condición de Residencia"
          control={form.control}
          defaultValue={form.getValues().condicion_residencia || ""}
          error={!!errors.condicion_residencia as any}
          helperText={errors.condicion_residencia?.message?.toString() ?? ""}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        /> */}
      </>

      {/* -------- Observaciones -------- */}
      {/* <TabTextLabel text="Observaciones" pb="24px" pt="48px" /> */}
      <>
        {/* <CustomTextAreaNoForm
          label="Observación 1 Vendedor"
          value={form.getValues()?.observacion_1 as string || '***NO SE TIENE OBSERVACIÓN 1 DE VENDEDOR***'}
          disabled
        />
        <CustomTextAreaNoForm
          label="Observación 2 Vendedor"
          value={form.getValues()?.observacion_2 as string || '***NO SE TIENE OBSERVACIÓN 2 DE VENDEDOR***'}
          disabled
        />
        <CustomTextAreaNoForm
          label="Observación Llamada"
          value={form.getValues()?.observacion_llamada as string || '***NO SE TIENE OBSERVACIÓN DE LLAMADA***'}
          disabled
        /> */}
      </>
    </>
  );
};

export default ActivacionInstallOTClientDataFormTab;
